import { Taxgroup } from './Taxgroup.model';

export interface IOrderlineSimple {
  id: number;
  uuid: string;
  text: string;
  type: string;
}

export type IOrderline = {
  id: number;
  uuid: string;
  providerName: string;
  providerUUID: string;
  providerId: number;
  createdDate: string;
  createdDateUTC: string;
  type: string;
  orderId: number;
  customerId: number;
  customerUUID: string;
  customerDisplayname: string;
  orderNumber: string;
  cashDiscPercent: number;
  orderDate: string;
  orderDateUTC: string;
  itemId: string;
  text: string;
  paymentStatus: string;
  salesPrice: number;
  qty: number;
  lineAmount: number;
  dueDate: string;
  amountDue: number;
  creditsTotal: number;
  creditsLeft: number;
  unitsLeft: number;
  expirationDate: string;
  expirationDateUTC: string;
  currencyName: string;
  currencySymbol: string;
  renew: boolean;
  nextCancellationDate: string;
  nextCancellationDateUTC: string;
  archived: boolean;
  origin: string;
  active: boolean;
  archivationDate: string;
  archivationDateUTC: string;
  notes: string;
  taxGroup: Taxgroup;
  nextDueDate: string;
  paymentType: string;
  paymentMethod: string;
  invoiceId: number;
  invoiceNumber: string;
  canCreateInvoice: boolean;
  orderNote: string;
  productId: number;
  productUUID: string;
  isCancelled: boolean;
  imageUrl: string;
  voucherCode: string;
  signedContractId: string;
};

export type ICreateOrderline = Partial<{
  productId: number;
  paymentType: string;
  domain: string;
  dueDate: string;
  origin: string;
  dueDateUTC: string;
  eventId: string;
  existingBookingId: number;
  tempDisablePayment: boolean;
  defaultTransactionsUntil: string;
  asVoucher: boolean;
  signedContractId: string;
}>;

export enum OrderlineType {
  CONTRACT = 'OrderLineContract',
  CREDITPASS = 'OrderLineCreditpass',
  SINGLEEVENT = 'OrderLineSingleEvent',
  COURSE = 'OrderLineCourse',
  ExternalParty = 'OrderLineExternalParty',
}
